import React from 'react'
import './style.css'

const Experience = () => {
  return (
    <>
   <div className='Experience '  >
     <div className="ExperienceInfo " style={{textDecoration:'none',textAlign:'start',color:'white'}}>
       <h3 style={{fontWeight:'600'}}>EXPERIENCE</h3>
       <p>3 Months</p>
    </div>
    
     <div className="ExperienceInfo" style={{textDecoration:'none',textAlign:'start',color:'white'}}>
       <h3 style={{fontWeight:'600'}}>AI ML Intern</h3>
       <p>YBI FOUNDATION</p>
    </div>
   
     <div className="ExperienceInfo " style={{textDecoration:'none',textAlign:'start',color:'white'}}>
       <p>2021-2023</p>
       <h3 style={{fontWeight:'600'}}>Personal Projects</h3>
    </div>
    
   </div>
    
    </>
  )
}

export default Experience
